import { CommonModule as AngularCommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RivModule } from '@rivet-health/design-system';
import { AnimationModule } from '../animation/module';
import { ComponentsModule } from '../components/module';
import { CoreModule } from '../core/module';
import { InputModule } from '../input/no-worker-module';
import { LoadModule } from '../load/module';
import { ModalModule } from '../modal/module';
import { RivvyOutletComponent, SafeHtmlPipe } from './rivvy-outlet.component';

@NgModule({
  declarations: [RivvyOutletComponent, SafeHtmlPipe],
  exports: [RivvyOutletComponent],
  imports: [
    AngularCommonModule,
    AnimationModule,
    ComponentsModule,
    CoreModule,
    FormsModule,
    InputModule,
    LoadModule,
    RivModule,
    ModalModule,
  ],
})
export class RivvyModule {}
